import { render } from "./HistoryIcon.vue?vue&type=template&id=6042bcc4"
import script from "./HistoryIcon.vue?vue&type=script&lang=js"
export * from "./HistoryIcon.vue?vue&type=script&lang=js"
script.render = render

export default script